import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6a3b76d3")

_pushScopeId("data-v-6a3b76d3")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "notification" }, [
  /*#__PURE__*/_createTextVNode(" To ensure smooth functionality with the demo app, we recommend using "),
  /*#__PURE__*/_createVNode("strong", null, "Chrome"),
  /*#__PURE__*/_createTextVNode(", as Safari’s stricter third-party cookie policies can affect integration unless a matching subdomain is set up. Configuring a subdomain binding with an SSL certificate on your Infigo storefront is necessary for compatibility across browsers. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title is-3" }, "Setup", -1)
const _hoisted_4 = { class: "field" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { class: "label" }, "Infigo Platform URL:", -1)
const _hoisted_6 = { class: "control" }
const _hoisted_7 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_8 = { class: "field" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "label" }, "API Token:", -1)
const _hoisted_10 = { class: "control" }
const _hoisted_11 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "field" }, [
  /*#__PURE__*/_createVNode("div", { class: "control" }, [
    /*#__PURE__*/_createVNode("button", {
      type: "submit",
      class: "button is-primary"
    }, "Save")
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title),
    _hoisted_2,
    _hoisted_3,
    _createVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSetup && _ctx.saveSetup(...args)), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _withDirectives(_createVNode("input", {
            class: "input",
            type: "url",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.platformUrl = $event)),
            required: "",
            placeholder: "Enter platform URL"
          }, null, 512), [
            [_vModelText, _ctx.platformUrl]
          ])
        ]),
        (!_ctx.platformUrl && _ctx.submitted)
          ? (_openBlock(), _createBlock("p", _hoisted_7, " Platform URL is required "))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _withDirectives(_createVNode("input", {
            class: "input",
            type: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.apiToken = $event)),
            required: "",
            placeholder: "Enter API token"
          }, null, 512), [
            [_vModelText, _ctx.apiToken]
          ])
        ]),
        (!_ctx.apiToken && _ctx.submitted)
          ? (_openBlock(), _createBlock("p", _hoisted_11, " API Token is required "))
          : _createCommentVNode("", true)
      ]),
      _hoisted_12
    ], 32)
  ]))
})